/*
 * File: Alerts.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates and Styles the Patient > Alerts view
 */
/**
 * Alerts.js
 *
 * Renders a label and list of alerts for each alert type a patient has
 */
import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core";
import AlertListItems from "./AlertListItems";

const styles = theme => ({
  labels: {
    padding: 10,
    paddingLeft: 20,
    fontWeight: 400,
    color: theme.palette.common.title,
    // need to turn the span into a div because of material ui nesting div errors
    display: "block"
  },
  patient: {
    background: "#ffffac"
  },
  account: {
    background: "#c9f8cc"
  },
  allergy: {
    background: "#ffcdcf"
  }
});

const Alerts = ({ classes, type, label, alerts }) => {
  // concats classnames for the labels and type of alert
  let labelClass = classes.labels + " " + classes[type];
  return (
    <div>
      <Typography variant="h5" className={labelClass}>
        {label}
      </Typography>
      <AlertListItems alerts={alerts} />
    </div>
  );
};

Alerts.propTypes = {
  classes: PropTypes.object,
  type: PropTypes.string,
  label: PropTypes.string,
  alerts: PropTypes.array
};

export default withStyles(styles)(Alerts);
